export default {
	title: 'Consulting appointment',
	description: 'You can change the local time, language and currency to further set up a consultation appointment.',
	languageTitle: 'Language',
	languageTitleRight: 'English',
	currencyTitle: 'Currency',
	currencyTitleValue: {
		Rial: 'Rial',
		Dollar: 'CAD',
		'+03:30': 'Tehran',
		'-07:00': 'Canada'
	},
	timezoneTitle: 'Time Zone',
	languageDescription: 'By selecting the language, only the list of consultants who speak this language will be displayed.',
	currencyDescription: 'Payment of consultation fee will be made with the selected currency.',
	timezoneDescription: 'All reservations will be at your local time of your choice.',
	button: 'Start booking time',

	radioSelect: {
		enLanguage: 'English',
		faLanguage: 'Persian'
	},

	tehranTimezone: 'Tehran',
	canadaTimezone: 'Canada',
	time: 'Time',
	dollar: 'CAD',
	rial: 'Toman',
	duration: 'min',
	timezoneSearch: 'Search by country and city title',

	htmlTitle: '| Consulting appointment reservation system',

	pm: 'PM',
	am: 'AM',

	free: 'Free'
}
